import LoaderScreen from './LoaderScreen';

export default LoaderScreen;
